import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import { DIALOG_DATA } from '@ansys-internal/awf-angular/shared';
import { ButtonComponent } from '@ansys-internal/awc-angular/buttons';
import { LogoComponent } from '@ansys-internal/awc-angular/images';
import { APP_VERSION } from '../../../tokens/app-version.token';
import { TITLE } from '@ansys-internal/awf-angular/auth';
import { SystemStatusService } from '../../../../api';
import { lastValueFrom } from 'rxjs';
import { IconComponent, Icons } from '@ansys-internal/awc-angular/icons';
import { RequirementsService } from '../../../shared/services/requirements.service';


@Component({
    selector: 'app-about',
    imports: [LogoComponent, IconComponent],
    templateUrl: './about.component.html',
    styleUrl: './about.component.scss'
})
export class AboutComponent {
  protected apiVersion?: { version: string };
  protected api?: string;
  protected latestSolverVersion?: string;
  // eslint-disable-next-line @typescript-eslint/naming-convention
  protected readonly Icons = Icons;

  constructor(
    @Inject(DIALOG_DATA) public data: undefined,
    @Inject(APP_VERSION) protected version: string,
    @Inject(TITLE) protected appName: string,
    private systemStatusApiService: SystemStatusService,
    private cdr: ChangeDetectorRef,
    private requirementsService: RequirementsService
  ) {
    this.getApiVersion();
    this.getLatestSolverVersion();
  }

  async getApiVersion(): Promise<void> {
    this.apiVersion = (await lastValueFrom(
      this.systemStatusApiService.versionVersionGet()
    )) as { version: string };
    this.cdr.detectChanges();
  }

  async getLatestSolverVersion(): Promise<void> {
    const versions = await this.requirementsService.getVersions();
    this.latestSolverVersion = versions[0].version;
    this.cdr.detectChanges();
  }
}
